import Vue from 'vue';

const success = (context, response) => {
  if (response.restrictions) {
    const [rentalAvailabilities] = Object.values(response.restrictions);
    if (rentalAvailabilities) {
      context.booking.price = rentalAvailabilities.price ? rentalAvailabilities.price : 0;
      context.setTaxes(true, rentalAvailabilities.city_taxes, rentalAvailabilities.cleaning);
    }
  }
  
  context.priceCalculationLoading = false;
};

const failed = (context, error) => {
  context.priceCalculationLoading = false;
};

export default (context, data) => Vue.$http.post('get-availabilities', data)
  .then((response) => {
    success(context, response.data);
  }).catch((error) => {
    failed(context, error);
  });



// WEBPACK FOOTER //
// ./src/app/services/rental/getRoomAvailabilities.js